export default "__VITE_ASSET__d27584e4__"